import { Serializer } from "../utils/Serializer";

export class BitmapMoneyText extends PIXI.Container {
    protected _moneyText: PIXI.extras.BitmapText;
    protected _centsText: PIXI.extras.BitmapText;
    protected _currencyText: PIXI.extras.BitmapText;
    protected _suffix: PIXI.extras.BitmapText;
    private _config: MoneyTextConfig;
    private _diamondImage: PIXI.Sprite;
    private _rect: PIXI.Graphics;

    constructor(config: any) {
        super();

        this._config = new MoneyTextConfig();
        this._config.serialize(config);
        if (this._config.centsFontSize == undefined)
            this._config.centsFontSize = this._config.moneyFontSize;
        if (this._config.currencyFontSize == undefined)
            this._config.currencyFontSize = this._config.moneyFontSize;
        if (this._config.suffixFontSize == undefined)
            this._config.suffixFontSize = this._config.moneyFontSize;
        if (this._config.centsfontFamily == undefined)
            this._config.centsfontFamily = this._config.fontFamily;
        if (this._config.currencyfontFamily == undefined)
            this._config.currencyfontFamily = this._config.fontFamily;
        if(this._config.suffixfontFamily == undefined)
            this._config.suffixfontFamily = this._config.fontFamily


        this._rect = new PIXI.Graphics();
        this._rect.beginFill(0xff0000, 1);
        this._rect.drawRect(0, 0, this._config.bounds.width, this._config.bounds.height);
        this._rect.endFill();
        this.addChild(this._rect);
        this._rect.visible = true;
        this._rect.alpha = 0;
        if (this._config.debug) {
            this._rect.alpha = 1;
        }

        this.createTextFields();

        if (this._config.diamond) {
            this._diamondImage = new PIXI.Sprite(this._config.diamond);
            this.addChild(this._diamondImage);
            this._diamondImage.anchor.set(0.5);
            this._diamondImage.visible = false;
        }
    }

    get moneyTextFontSize(): number {
        return (this._moneyText.font as any).size as number
    }

    get money(): number {
        return this._config.money;
    }

    set align(value:string) {
        this._config.align = value;
        this.fitToBounds();
        this.positionText();
    }

    set bounds(value:any){
        this._config.bounds = { width: value.width, height: value.height };

        this._rect.width = value.width;
        this._rect.height = value.height;

        this.fitToBounds();
        this.positionText();
    }

    get bounds():any{
        return {width: this._config.bounds.width, height: this._config.bounds.height}
    }

    set isShowingCredits(val: boolean) {
        if (this._config.diamondPlay) {
            if (this._config.isShowingCredits) {
                this._config.isShowingCredits = false;
                this.money = this._config.money;
            }

            return;
        }

        this._config.isShowingCredits = val;
        this.money = this._config.money;
    }

    set denomination(val: number) {
        this._config.denomination = val;
        this.money = this._config.money;
    }

    set prefix(value: string) {
        this._config.prefix = value;
        this._moneyText.text = this._config.moneyString;

        this.fitToBounds();
        this.positionText();
    }

    set suffix(value: string) {
        this._config.suffix = value;
        this._suffix.text = this._config.suffix;
        this._suffix.visible = true;
        this.fitToBounds();
        this.positionText();
    }

    recalcVerticalOffset(){
        if (isNaN(this._config.centsPositionOffsetPercentY))
            this._config.centsOffsetCalc(this._centsText.y, this._moneyText.textHeight);

        if (isNaN(this._config.currencyPositionOffsetPercentY))
            this._config.currencyOffsetCalc(this._currencyText.y, this._moneyText.textHeight);
    }

    set money(value: number) {
        this._config.money = value;
        this._moneyText.x = 0;
        this._moneyText.y = 0;
        this._centsText.x = 0;
        this._currencyText.x = 0;

        this._moneyText.text = this._config.moneyString;
        this._centsText.text = this._config.centsString;

        this.resetCentsTextWidthHeight();
        this.resetMoneyTextWidthHeight();

        this.recalcVerticalOffset();

        if (this._config.shouldHideWhenMoneyValueIsZero && value == 0) {
            this._moneyText.visible = false;
            this._centsText.visible = false;
            this._currencyText.visible = false;
            if (this._diamondImage)
                this._diamondImage.visible = false;
        }
        else {
            if (this._diamondImage) {
                this._diamondImage.visible = true;
            }

            this._moneyText.visible = true;
            this._centsText.visible = this._config.shouldCentsHaveValue;
            this._currencyText.visible = !this._config.isShowingCredits &&
                this._config.shouldShowCurrency && !this._config.diamond;
        }

        if (isNaN(this._config.currencyPositionOffsetPercentX)) {
            this._currencyText.text = " " + this._config.currency;
            this.resetCurrencyTextWidthHeight();
        } else {
            this._currencyText.text = "" + this._config.currency;
            this.resetCurrencyTextWidthHeight();
        }

        this.fitToBounds();
        this.positionText();
    }

    set moneyTextPositionY(y: number) {
        this._moneyText.y = y;
    }

    set centsTextPositionY(y: number) {
        this._centsText.y = y;
        if (this._moneyText.textHeight > 0) {
            this._config.centsOffsetCalc(this._centsText.y, this._moneyText.textHeight);
        }
    }

    set currencyTextPositionY(y: number) {
        this._currencyText.y = y;

        if (this._moneyText.textHeight > 0) {
            this._config.currencyOffsetCalc(this._currencyText.y, this._moneyText.textHeight);
        }
    }

    set font(fontObj: any) {
        this._moneyText.x = 0;
        this._moneyText.y = 0;
        this._centsText.x = 0;
        this._centsText.y = 0;
        this._currencyText.x = 0;
        this._currencyText.y = 0;
        this._suffix.x = 0;
        this._suffix.y = 0;

        this._moneyText.font = fontObj;
        this._centsText.font = fontObj;
        this._currencyText.font = fontObj;
        this._suffix.font = fontObj;

        this._config.fontFamily = fontObj.name;
        this._config.moneyFontSize = fontObj.size;

        this._config.centsfontFamily = fontObj.name;
        this._config.centsFontSize = fontObj.size;

        this._config.currencyfontFamily = fontObj.name;
        this._config.currencyFontSize = fontObj.size;

        this._config.suffixfontFamily = fontObj.name;
        this._config.suffixFontSize = fontObj.size;


        this._config.centsPositionOffsetPercentY = NaN;
        this._config.currencyPositionOffsetPercentY = NaN;
        this._config.centsPositionOffsetPercentX = NaN;
        this._config.currencyPositionOffsetPercentX = NaN;
        this._config.letterSpacing = fontObj.letterSpacing || 0;

        this.recalcVerticalOffset();

        this.resetAllTextWidthHeight();

        this.fitToBounds();
        this.positionText();
    }
    get font():any {
        return {name: this._config.fontFamily, size: this._config.moneyFontSize};
    }

    set moneyFont(moneyFontObj: any) {
        this._moneyText.x = 0;
        this._moneyText.font = moneyFontObj;
        this._config.fontFamily = moneyFontObj.name;
        this._config.moneyFontSize = moneyFontObj.size;

        this.recalcVerticalOffset();

        this.resetMoneyTextWidthHeight();

        this.fitToBounds();
        this.positionText();
    }
    get moneyFont(): any {
        return {name: this._config.fontFamily, size: this._config.moneyFontSize};
    }

    set centsFont(font: any) {
        this._centsText.x = 0;
        this._centsText.y = 0;
        this._centsText.font = font;
        this._config.centsfontFamily = font.name;
        this._config.centsFontSize = font.size;

        this._config.centsPositionOffsetPercentX = NaN;
        this._config.centsPositionOffsetPercentX = NaN;

        this.recalcVerticalOffset();

        this.resetCentsTextWidthHeight();

        this.fitToBounds();
        this.positionText();
    }
    get centsFont(): any {
        return {name: this._config.centsfontFamily, size: this._config.centsFontSize};
    }

    set suffixFont(font: any) {
        this._suffix.x = 0;
        this._suffix.y = 0;
        this._suffix.font = font;
        this._config.suffixfontFamily = font.name;
        this._config.suffixFontSize = font.size;

        this.resetSuffixWidthHeight();

        this.fitToBounds();
        this.positionText();
    }

    get suffixFont(): any {
        return {name: this._config.suffixfontFamily, size: this._config.suffixFontSize};
    }

    set currencyFont(font: any) {
        this._currencyText.x = 0;
        this._currencyText.y = 0;
        this._currencyText.font = font;
        this._config.currencyfontFamily = font.name;
        this._config.currencyFontSize = font.size;

        this._config.currencyPositionOffsetPercentY = NaN;
        this._config.currencyPositionOffsetPercentX = NaN;

        this.recalcVerticalOffset();

        this.resetCurrencyTextWidthHeight();

        this.fitToBounds();
        this.positionText();
    }

    get currencyFont(): any {
        return {name: this._config.currencyfontFamily, size: this._config.currencyFontSize};
    }

    set tint(value: number) {
        this._moneyText.tint = value
        this._centsText.tint = value
        this._currencyText.tint = value
        this._suffix.tint = value
    }

    set moneyTint(value: number) {
        this._moneyText.tint = value
    }

    set centsTint(value: number) {
        this._centsText.tint = value
    }

    set currencyTint(value: number) {
        this._currencyText.tint = value
    }

    set suffixTint(value: number) {
        this._suffix.tint = value
    }

    set scaleDiamond(value: number) {
        this._diamondImage.scale.set(value, value);
        this.fitToBounds();
        this.positionText();
    }

    private resizeDiamond() {
        this._diamondImage.scale.set(1);
        const diamandScaleToSet: number = (this._moneyText.textHeight / this._diamondImage.height) * this._config.diamondScaleCoef;
        this._diamondImage.scale.x = diamandScaleToSet;
        this._diamondImage.scale.y = diamandScaleToSet;
    }

    set setScaleDiamondCoef(value: number) {
        this._config.diamondScaleCoef = value;
    }

    protected createTextFields() {
        var textStyle = {
            font: {
                name: this._config.fontFamily,
                size: this._config.moneyFontSize
            },
            align: 'left',
            tint: this._config.moneyTint
        };

        this._moneyText = new PIXI.extras.BitmapText("", textStyle);
        this._moneyText.letterSpacing = this._config.letterSpacing;

        textStyle = {
            font: {
                name: this._config.centsfontFamily,
                size: this._config.centsFontSize
            },
            align: 'left',
            tint: this._config.centsTint
        };

        this._centsText = new PIXI.extras.BitmapText("", textStyle);
        this._centsText.letterSpacing = this._config.letterSpacing;

        textStyle = {
            font: {
                name: this._config.currencyfontFamily,
                size: this._config.currencyFontSize
            },
            align: 'left',
            tint: this._config.currencyTint
        };

        this._currencyText = new PIXI.extras.BitmapText(this._config.currency, textStyle);
        this._currencyText.letterSpacing = this._config.letterSpacing;

        textStyle = {
            font: {
                name: this._config.suffixfontFamily,
                size: this._config.suffixFontSize
            },
            align: 'left',
            tint: this._config.suffixTint
        };

        this._suffix = new PIXI.extras.BitmapText(this._config.suffix, textStyle);
        this._suffix.letterSpacing = this._config.letterSpacing;

        this.resetAllTextWidthHeight();

        this.addChild(this._moneyText);
        this.addChild(this._centsText);
        this.addChild(this._currencyText);
        this.addChild(this._suffix);

        this._moneyText.visible = false;
        this._centsText.visible = false;
        this._currencyText.visible = false;
        this._suffix.visible = false;
    }

    protected positionText() {
        this._moneyText.x = 0;
        this._moneyText.y = 0;
        this._centsText.x = 0;
        this._centsText.y = 0;
        this._currencyText.x = 0;
        this._currencyText.y = 0;
        this._suffix.x = 0;
        this._suffix.y = 0;

        if (this._config.bounds.height == 0 || this._config.verticalAlign === "top") {
            this._moneyText.y = 0;
        } else if (this._config.verticalAlign == "middle") {
            this._moneyText.y = (this._config.bounds.height - this._moneyText.textHeight) / 2;
        } else if (this._config.verticalAlign == "bottom") {
            this._moneyText.y = this._config.bounds.height - this._moneyText.textHeight;
        }

        this._suffix.y = this._moneyText.y + this._moneyText.textHeight - this._suffix.textHeight;

        if (this._config.diamond) {
            this._diamondImage.y = this._moneyText.y + this._moneyText.textHeight / 2;
        }

        if (this._config.align == "left") {
            if (this._config.diamond) {
                this._diamondImage.x = this._diamondImage.width / 2;
                this._moneyText.x = this._diamondImage.width + this._config.spaceBetweenMoneyAndDiamond + this.moneyTextLetterSpacing;
            }
        }
        else if (this._config.align == "right") {
            if (this._config.diamond) {
                this._moneyText.x = this._config.bounds.width - this._moneyText.textWidth;
                this._diamondImage.x = this._moneyText.x - this._config.spaceBetweenMoneyAndDiamond - this._diamondImage.width / 2 +
                    this.moneyTextLetterSpacing;
            } else {
                this._moneyText.x = this._config.bounds.width - this.textWidth;
            }
        }
        else {
            if (this._config.diamond) {
                this._moneyText.x = (this._config.bounds.width - this.textWidth) / 2;
                if (this._config.centerAlignOnlyMoney) {
                    this._moneyText.x += (this._diamondImage.width + this._config.spaceBetweenMoneyAndDiamond) / 2 -
                        this.moneyTextLetterSpacing;
                    this._diamondImage.x = this._moneyText.x - this._diamondImage.width / 2 - this._config.spaceBetweenMoneyAndDiamond;
                } else {

                    this._diamondImage.x = this._moneyText.x + this._diamondImage.width / 2;
                    this._moneyText.x += this._diamondImage.width + this._config.spaceBetweenMoneyAndDiamond +
                        this.moneyTextLetterSpacing;
                }
            } else {
                this._moneyText.x = (this._config.bounds.width - this.textWidth) / 2;
                if (this._config.centerAlignOnlyMoney && !this._config.isShowingCredits)
                    this._moneyText.x += this._currencyText.width / 2;
            }
        }

        this._suffix.x = this._moneyText.x + this._moneyText.textWidth;
        if (this._centsText.visible) {
            this.calcHorizontalOffset();
            this._centsText.x = this._moneyText.x + this._moneyText.textWidth + this._config.spaceBetweenMoneyAndCents;
            this._centsText.y = this._moneyText.y + this._moneyText.textHeight * this._config.centsPositionOffsetPercentY;
            this._suffix.x = this._centsText.x + this._centsText.textWidth;
        }


        // TODO: replace this check with this._currencyText.visible
        if (!this._config.isShowingCredits && this._config.shouldShowCurrency) {
            const leftText = this._centsText.visible ? this._centsText : this._moneyText;
            this._currencyText.x = leftText.x + leftText.width +
                ( !isNaN(this._config.currencyPositionOffsetPercentX) ? this._config.currencyPositionOffsetPercentX *
                    this._moneyText.textHeight : 0);
            this._currencyText.y = this._moneyText.y + this._moneyText.textHeight * this._config.currencyPositionOffsetPercentY;
            this._suffix.x = this._currencyText.x + this._currencyText.textWidth;
        }

        this._moneyText.x = Math.round(this._moneyText.x);
        this._moneyText.y = Math.round(this._moneyText.y);
        this._centsText.x = Math.round(this._centsText.x);
        this._centsText.y = Math.round(this._centsText.y);
        this._currencyText.x = Math.round(this._currencyText.x);
        this._currencyText.y = Math.round(this._currencyText.y);
        this._suffix.x = Math.round(this._suffix.x);
        this._suffix.y = Math.round(this._suffix.y);
    }

    get textWidth(): number {
        this._moneyText.width;
        this._centsText.width;
        this._currencyText.width;
        this.resetSuffixWidthHeight();


        const moneyWidth = this._moneyText.textWidth;

        if (!this._config.isShowingCredits && !this._config.diamondPlay)
            this.calcHorizontalOffset();

        const centsWidth = this._centsText.visible ? this._centsText.textWidth +
            (isNaN(this._config.spaceBetweenMoneyAndCents) ? 0 : this._config.spaceBetweenMoneyAndCents) : 0;

        const currencyWidth = this._config.isShowingCredits ||
        !this._config.shouldShowCurrency ? 0 : this._config.diamond ? this._diamondImage.width +
            this._config.spaceBetweenMoneyAndDiamond + this.moneyTextLetterSpacing :
            this._currencyText.textWidth +
            (isNaN(this._config.spaceBetweenCentsAndCurrency) ? 0 : this._config.spaceBetweenCentsAndCurrency);

        const suffixWidth = this._config.suffix?this._suffix.textWidth:0;

        return moneyWidth + centsWidth + currencyWidth + suffixWidth;
    }

    setCentsPositionOffsetPercentX(muneyEnd: number, centsBegin: number, moneyTextHeight: number) {
        this._config.centsPositionOffsetPercentX = centsBegin == muneyEnd ? 0 : (centsBegin - muneyEnd) / moneyTextHeight;
    }

    setCurrencyPositionOffsetPercentX(centsEnd: number, currencyBegin: number, moneyTextHeight: number) {
        this._config.currencyPositionOffsetPercentX = currencyBegin == centsEnd ? 0 : (currencyBegin - centsEnd) / moneyTextHeight;
    }

    get moneyTextLetterSpacing(): number {
        this._moneyText.text = "111111";
        this.resetMoneyTextWidthHeight();


        var letterSpacing: number = this._moneyText.children[1].x -
            this._moneyText.children[0].x -
            (this._moneyText.children[0] as any).width;

        this._moneyText.text = this._config.moneyString;
        this.resetMoneyTextWidthHeight();

        if (letterSpacing < 0) {
            letterSpacing /= 2;
        } else {
            letterSpacing = 0;
        }

        return letterSpacing;
    }


    protected calcHorizontalOffset() {
        this._moneyText.text = "111111";
        this.resetMoneyTextWidthHeight();

        var letterSpacing: number = this._moneyText.children[1].x -
            this._moneyText.children[0].x -
            (this._moneyText.children[0] as any).width;
        this._moneyText.text = this._config.moneyString;
        this.resetMoneyTextWidthHeight();

        if (!isNaN(this._config.centsPositionOffsetPercentX))
            letterSpacing = 0;

        this._config.spaceBetweenMoneyAndCents = letterSpacing + (!isNaN(this._config.centsPositionOffsetPercentX) ?
            this._config.centsPositionOffsetPercentX * this._moneyText.textHeight : 0);

        this._centsText.text = "111111";
        this.resetCentsTextWidthHeight();

        letterSpacing = this._centsText.children[1].x -
            this._centsText.children[0].x -
            (this._centsText.children[0] as any).width;

        this._centsText.text = this._config.centsString;
        this.resetCentsTextWidthHeight();

        if (!isNaN(this._config.currencyPositionOffsetPercentX))
            letterSpacing = 0;

        this._config.spaceBetweenCentsAndCurrency = letterSpacing + (!isNaN(this._config.currencyPositionOffsetPercentX) ?
            this._config.currencyPositionOffsetPercentX * this._moneyText.textHeight : 0);

    }

    private resetAllTextWidthHeight() {
        this.resetMoneyTextWidthHeight();
        this.resetCentsTextWidthHeight();
        this.resetCurrencyTextWidthHeight();
        this.resetSuffixWidthHeight();
    }

    private resetCurrencyTextWidthHeight() {
        this._currencyText.height;
        this._currencyText.width;
    }

    private resetCentsTextWidthHeight() {
        this._centsText.height;
        this._centsText.width;
    }

    private resetMoneyTextWidthHeight() {
        this._moneyText.height;
        this._moneyText.width;
    }

    private resetSuffixWidthHeight() {
        this._suffix.height;
        this._suffix.width;
    }

    dispose() {
        this._moneyText.destroy();
        this._centsText.destroy();
        this._currencyText.destroy();
    }

    protected resetFonts() {
        this._moneyText.font = {
            name: this._config.fontFamily,
            size: this._config.moneyFontSize
        };
        this._moneyText.align = "left"

        this._centsText.font = {
            name: this._config.centsfontFamily,
            size: this._config.centsFontSize
        }
        this._centsText.align = "left"

        this._currencyText.font = {
            name: this._config.currencyfontFamily,
            size: this._config.currencyFontSize
        }
        this._currencyText.align = "left"

        this._suffix.font = {
            name: this._config.suffixfontFamily,
            size: this._config.suffixFontSize
        }
        this._suffix.align = "left"

        this.resetAllTextWidthHeight();
    }

    protected fitToBounds() {
        this.resetFonts();

        if (this._config.diamond) {
            this.resizeDiamond();
        }

        if (!this._config.shouldFitToBounds)
            return;

        // TODO: implement scaling of all 3 fields
        let currencyCompensation: number = 0;
        if (this._config.centerAlignOnlyMoney && this._config.align == "center") {
            currencyCompensation = this._config.diamond ? this._diamondImage.width + this._config.spaceBetweenMoneyAndDiamond :
                this._currencyText.width;
        }


        let moneyFontSize: number = (this._moneyText.font as any).size as number;
        let centsFontSize: number = (this._centsText.font as any).size as number;
        let currencyFontSize: number = (this._currencyText.font as any).size as number;
        let suffixFontSize: number = (this._suffix.font as any).size as number;

        while (this.textWidth > this._config.bounds.width - currencyCompensation && moneyFontSize > this._config.minFontSize) {
            const coefCurrency: number = this._config.diamond ? this._config.diamondScaleCoef : currencyFontSize / moneyFontSize;
            const coefCents: number = centsFontSize / moneyFontSize;
            const coefSuffix:number = suffixFontSize/moneyFontSize;

            moneyFontSize--;
            this._moneyText.font = {
                // tint: (this._moneyText.font as any).tint,
                // align: "left",
                name: this._config.fontFamily,
                size: moneyFontSize
            };
            centsFontSize = moneyFontSize * coefCents;
            this._centsText.font = {
                // tint: (this._centsText.font as any).tint,
                // align: "left",
                name: this._config.centsfontFamily,
                size: centsFontSize
            }

            currencyFontSize = moneyFontSize * coefCurrency;

            if (this._config.diamond != null && !this._config.keepDiamondSize) {
                this.resizeDiamond();
            }
            else if (!this._config.keepCurrencySize) {
                this._currencyText.font = {
                    // tint: (this._currencyText.font as any).tint,
                    // align: "left",
                    name: this._config.currencyfontFamily,
                    size: currencyFontSize
                }
            }

            suffixFontSize = moneyFontSize * coefSuffix;
            this._suffix.font = {
                // tint: (this._suffix.font as any).tint,
                // align: "left",
                name: this._config.suffixfontFamily,
                size: suffixFontSize
            }


        }

    }
}

class MoneyTextConfig extends Serializer {
    money: number = 0;
    prefix: string = "";
    suffix:string="";
    denomination: number = 1;
    currency: string = "";
    centsVisibilityMoneyLimit: number = -1;
    isShowingCredits: boolean = false;
    fontFamily: string = "MyCustomFont";
    centsfontFamily: string = undefined;
    currencyfontFamily: string = undefined;
    suffixfontFamily: string = undefined;
    align: string = "center";
    verticalAlign: string = "middle";

    moneyTint: number = 16777215;
    centsTint: number = 16777215;
    currencyTint: number = 16777215;
    suffixTint: number = 16777215;

    moneyFontSize: number = 1;
    centsFontSize: number = undefined;
    currencyFontSize: number = undefined;
    suffixFontSize: number = undefined;

    spaceBetweenMoneyAndCents: number = NaN;
    spaceBetweenCentsAndCurrency: number = NaN;
    spaceBetweenMoneyAndDiamond: number = 5;
    shouldShowCurrency: boolean = true;
    centerAlignOnlyMoney: boolean = false;
    shouldHideWhenMoneyValueIsZero: boolean = false;
    minFontSize: number = 6;
    bounds: any = {width: 100, height: 50};
    shouldFitToBounds: boolean = true;
    debug: boolean = false;
    diamond: PIXI.Texture = null;
    diamondScaleCoef: number = 1;
    posDiamondY: number = 0;
    diamondPlay: boolean = false;
    keepCurrencySize: Boolean = false;
    keepDiamondSize: Boolean = false;
    centsPositionOffsetPercentY: number = NaN;
    currencyPositionOffsetPercentY: number = NaN;
    centsPositionOffsetPercentX: number = NaN;
    currencyPositionOffsetPercentX: number = NaN;
    hideCents: boolean = false;
    letterSpacing: number = 0;
     /**
     * Whether to allow a different amount of numbers after the decimal point.
     * @example 123.45678 or 123.46
     * @type {boolean}
     */
    allowFlexibleDecimals: boolean = false;

    centsOffsetCalc(centsPosition: number, moneyTextHeight: number) {

        if (centsPosition == 0)
            this.centsPositionOffsetPercentY = 0;
        else
            this.centsPositionOffsetPercentY = centsPosition / moneyTextHeight;
    }

    currencyOffsetCalc(currencyPosition: number, moneyTextHeight: number) {
        if (currencyPosition == 0)
            this.currencyPositionOffsetPercentY = 0;
        else
            this.currencyPositionOffsetPercentY = currencyPosition / moneyTextHeight;
    }

    get moneyString(): string {
        let str: string = "";
        if (this.isShowingCredits) {
            str = Math.floor(this.money / this.denomination).toString();
        } else if (this.diamondPlay) {
            str = (this.money / 100).toFixed();
        } else {
            str = (this.money / 100).toFixed(2);
            const moneyParts = str.split(".");
            const moneyDigits = moneyParts[0].split('');

            let counter: number = 3;
            let digitIndex = moneyDigits.length;
            while (--digitIndex > 0) {
                counter--;
                if (counter == 0) {
                    counter = 3;
                    moneyDigits.splice(digitIndex, 0, " ");
                }
            }

            str = moneyDigits.join('') + (this.shouldCentsHaveValue ? "." : "");
        }

        if (this.prefix)
            str = this.prefix + str;

        return str;
    }

    get centsString(): string {
        let str = "";
        if (this.shouldCentsHaveValue) {
            if (this.allowFlexibleDecimals) {
                let decimals = 0;
                let tempMoney = this.money;

                while (tempMoney % 100 != 0) {
                    decimals += 1;
                    tempMoney *= 10;
                }
                decimals = Math.max(decimals, 2);

                str = (this.money / 100).toFixed(decimals).split(".")[1];
            } else str = (this.money / 100).toFixed(2).split(".")[1]; 
        }

        return str;
    }

    get shouldCentsHaveValue(): boolean {
        return !this.isShowingCredits && !this.diamondPlay && !this.hideCents &&
            (this.money <= this.centsVisibilityMoneyLimit || this.centsVisibilityMoneyLimit < 0);
    }
}